import React from 'react';
import { WidthProvider, Responsive } from 'react-grid-layout';

const ResponsiveGridLayout = WidthProvider(Responsive);

export default function PrivacyPolicy() {
  const updated = new Date().toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  });

  const layout = [
    { i: 'a', x: 1, y: 0, w: 7, h: 8, minW: 1, minH: 6 },
    { i: 'b', x: 0, y: 1, w: 1, h: 1, minW: 1, minH: 1 },
  ];

  return (
    <ResponsiveGridLayout
      className="layout"
      layouts={{ lg: layout }}
      breakpoints={{ lg: 1200, md: 996, sm: 768, xs: 480 }}
      cols={{ lg: 3, md: 3, sm: 3, xs: 1 }}
      rowHeight={100}
      draggableCancel=".cancelSelectorName"
      isDraggable={false}
      isResizable={false}
    >
      <div key="a" style={{ minHeight: "500px", overflowY: 'auto' }} className='card-gauge'>
        <div style={{ padding: '16px' }}>
          <header style={{ marginBottom: '16px' }}>
            <h1>ODP.Golf Privacy Policy</h1>
            <p style={{ fontSize: '0.9rem', color: '#6b7280' }}>Last updated: {updated}</p>
          </header>

          <section style={{ marginBottom: '16px' }}>
            <p>
              ODP.Golf values your privacy. This Privacy Policy explains how we collect,
              use, disclose, and protect information when you use our website and services, including SMS
              notifications, emails, and operational alerts. By using our services you agree to the terms described
              in this policy.
            </p>
          </section>

          <section style={{ marginBottom: '16px' }}>
            <h2>Information We Collect</h2>
            <ul>
              <li>Phone number(s) you provide when opting in to SMS alerts.</li>
              <li>Email address you provide when opting in to email alerts.</li>
              <li>Account information such as name, email, facility affiliation, and profile preferences.</li>
              <li>Technical and usage data (e.g. IP address, device information, browser type) to operate and improve the service.</li>
              <li>Operational telemetry required to generate alerts (e.g. device IDs, sensor readings, cart identifiers, location pings) — only when associated with your account or facility.</li>
            </ul>
          </section>

          <section style={{ marginBottom: '16px' }}>
            <h2>How We Use Your Information</h2>
            <ul>
              <li>To send operational and facility SMS/email alerts (equipment status, facility issues, pace-of-play notifications) to opted-in users.</li>
              <li>To provide, maintain, and improve our services and analytics.</li>
              <li>To respond to support requests and enforce our terms of service.</li>
              <li>To comply with legal obligations or protect the safety and security of our users.</li>
            </ul>
          </section>

          <section style={{ marginBottom: '16px' }}>
            <h2>Sharing of Information</h2>
            <p>
              We do not sell your personal information. We may share information with third-party service providers only as necessary to deliver the service — for example, Twilio for SMS delivery, SendGrid for email delivery, or a cloud host for storing telemetry. These providers are contractually required to protect your data and use it only to perform services for ODP.Golf.
            </p>
          </section>

          <section style={{ marginBottom: '16px' }}>
            <h2>SMS Messaging</h2>
            <p>
              By providing your phone number you agree to receive SMS alerts from ODP.Golf about facility operations and equipment status. Message and data rates may apply. Message frequency varies depending on events and facility activity.
            </p>
            <p>Opt-in methods include:</p>
            <ul>
              <li>
                Via the web: Log in and add your phone number at <a href="/account-settings">/account-settings</a> and check the SMS opt-in box which states: "By providing your phone number, you agree to receive text messages from ODP.Golf. Message and data rates may apply. Message frequency varies. You can opt out anytime by replying STOP, or get help by replying HELP. View our Privacy Policy: /privacy".
              </li>
              <li>
                Via text: Texting <strong>START</strong> to our dedicated phone number will opt you in and trigger a confirmation message. Reply <strong>STOP</strong> to unsubscribe, or <strong>HELP</strong> for assistance.
              </li>
            </ul>
          </section>

          <section style={{ marginBottom: '16px' }}>
            <h2>Data Security</h2>
            <p>
              We implement reasonable administrative, technical, and physical safeguards to protect your personal information. While we strive to protect your data, no electronic transmission or storage system is 100% secure — we cannot guarantee absolute security.
            </p>
          </section>

          <section style={{ marginBottom: '16px' }}>
            <h2>Your Choices</h2>
            <ul>
              <li>You may opt out of SMS alerts at any time by replying <strong>STOP</strong> to any message.</li>
              <li>For help, reply <strong>HELP</strong> to any message.</li>
              <li>
                To update or delete your account information, visit <a href="/account-settings">account settings</a> or contact us at <a href="mailto:admin@odp.golf">admin@odp.golf</a>.
              </li>
            </ul>
          </section>

          <section style={{ marginBottom: '16px' }}>
            <h2>Changes to This Policy</h2>
            <p>
              We may update this Privacy Policy from time to time. If we make material changes, we will notify users by posting the updated policy on this page with a revised "Last updated" date.
            </p>
          </section>

          <section>
            <h2>Contact Us</h2>
            <p>
              If you have questions about this policy, email us at <a href="mailto:admin@odp.golf">admin@odp.golf</a>.
            </p>
          </section>
        </div>
      </div>
      <div key="b" style={{ minHeight: "200px" }} className='card-gauge'></div>
    </ResponsiveGridLayout>
  );
}
